<template>
<div>
    <div id="main">
      <div class="inner">
            <heltecHeader></heltecHeader>
            <heltecHome v-if="isShowHome"></heltecHome>
            <heltecAboutUs v-if="isShowAboutus"></heltecAboutUs>
            <heltecShopInfortmation v-if="isShowShopInformation"></heltecShopInfortmation>
        <el-footer class="footer">
          <section>
            <el-row :gutter="20">
              <el-col :span="6">
              <!-- <div class="col-4 col-12-medium"> -->
                <img src="../assets/images/map.jpg" class="image">
              <!-- </div> -->
              </el-col>
              <!-- <div class="col-4 col-12-medium"> -->
              <el-col :span="6">
                <h3>關於我們</h3>
                <a class="logo" @click.prevent="jumpTo('Aboutus','BrandStory')">
                  <!-- <el-button type="text" >品牌故事</el-button> -->
                  <strong>品牌故事</strong>
                </a>
                <br />
                <a class="logo" @click.prevent="jumpTo('Aboutus','ShopIntroduce')">
                  <strong>商店介紹</strong>
                </a>
                <br />
                <a class="logo" @click.prevent="jumpTo('Aboutus','PrivacyPolicy')">
                  <strong>隱私權條款</strong>
                </a>
                <br />
                <a class="logo" @click.prevent="jumpTo('Aboutus','ContactUs')">
                  <strong>聯絡我們</strong>
                </a>
                <br />
                <a href="https://www.facebook.com/Heltec-Taiwan-629182457725418/" class="logo">
                  <strong>facebook</strong>
                </a>
              </el-col>
              <el-col :span="6">
              <div class="col-4 col-12-medium">
                <h3>購物說明</h3>
                <a class="logo" @click.prevent="jumpTo('Shopinformation','payment')">
                  <strong>付款方式</strong>
                </a>
                <br />
                <a class="logo" @click.prevent="jumpTo('Shopinformation','shipment')">
                  <strong>運送方式</strong>
                </a>
                <br />
                <a class="logo" @click.prevent="jumpTo('Shopinformation','return')">
                  <strong>退換貨方式</strong>
                </a>
                <br />
                <a href="https://line.me/ti/p/@790glkuc" class="logo">
                  <strong>Line@客服留言</strong>
                </a>
                <br />
                <a class="logo" @click.prevent="jumpTo('Shopinformation','right')">
                  <strong>會員權益說明</strong>
                </a>
                <br />
              </div>
              </el-col>
              <el-col :span="6">
              <!-- <div class="col-4 col-12-medium"> -->
                <h3>相關連結</h3>
                <a class="logo" href="https://heltec-automation-docs.readthedocs.io/en/latest/index.html#">
                  <strong>官方文件</strong>
                </a>
                <br />
                <a class="logo" href="http://community.heltec.cn/">
                  <strong>全球論壇</strong>
                </a>
                <br />
                <a class="logo" href="https://github.com/HelTecAutomation">
                  <strong>GitHub</strong>
                </a>
                <br />

              <!-- </div> -->
              </el-col>
            </el-row>
          </section>
        </el-footer>
      </div>
    </div>
</div>
</template>

<script>
// @ is an alias to /src
import heltecHeader from '../components/header.vue';
import heltecHome from '../components/heltecHome.vue';
import heltecAboutUs from '../components/Aboutus.vue';
import heltecShopInfortmation from '../components/Shopinformation.vue';

export default {
  name: 'Home',
  components: {
    heltecHeader, heltecHome, heltecAboutUs, heltecShopInfortmation,
  },
  data() {
    return {
      isShowHome: true,
      isShowAboutus: false,
      isShowShopInformation: false,
    };
  },

  mounted() {
    this.track();
  },
  methods: {
    track() {
      this.$ga.page('/');
    },
    jumpTo(document, hookName) {
      // eslint-disable-next-line no-console
      console.log('i am in jump to');
      this.isShowAboutus = false;
      this.isShowShopInformation = false;
      this.isShowHome = false;
      if (document === 'Aboutus') {
        this.isShowAboutus = true;
        // eslint-disable-next-line no-console
        console.log('i am in Aboutus');
        this.jump(hookName);
      } else if (document === 'Shopinformation') {
        // this.isShowAboutus = false;
        this.isShowShopInformation = true;
        this.jump(hookName);
      } else {
        this.isShowHome = true;
      }
    },
    jump(hookName) {
      const targetHookName = `#${hookName}`;
      const element = document.getElementById(targetHookName);
      try {
        element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' }, true);
      } catch (e) {
        // console.log(''); // 把例外物件傳給錯誤處理器
      }
    },
  },
};
</script>
